exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1cc43c6a] .v-list__tile--avatar{min-height:60px}.dooScroll[data-v-1cc43c6a]{max-height:500px;overflow-y:auto}", ""]);

// exports
